module.exports = __webpack_public_path__ + "static/img/10.18d5456.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/4/1/zh/10.png
// module id = xiG8
// module chunks = 0